import { Alert, Box, CircularProgress } from "@mui/material";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { ApiError } from "../api/http-client";
import { AsyncState } from "./use-async";

interface AsyncContentProps<T> {
    state: AsyncState<T>;
    children: (data: T) => ReactNode;
}

/** Shows a progress indicator while loading, a translated error on failure, and the content otherwise. */
export function AsyncContent<T>({ state, children }: AsyncContentProps<T>) {
    const { t } = useTranslation();
    if (state.status === "loading") {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
                <CircularProgress aria-label={t("common.loading")} />
            </Box>
        );
    }
    if (state.status === "error") {
        console.error(state.error);
        const code = state.error instanceof ApiError ? state.error.code : "INTERNAL_ERROR";
        return <Alert severity="error">{t(`error.${code}`, { defaultValue: t("error.INTERNAL_ERROR") })}</Alert>;
    }
    return <>{children(state.data)}</>;
}
